import { render, staticRenderFns } from "./CarWashAct.vue?vue&type=template&id=78db5eb7&scoped=true&"
import script from "./CarWashAct.vue?vue&type=script&lang=js&"
export * from "./CarWashAct.vue?vue&type=script&lang=js&"
import style0 from "./CarWashAct.vue?vue&type=style&index=0&id=78db5eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db5eb7",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QItemSection,QItemLabel,QChip,QAvatar,QBtn,QCardActions,QInput,QIcon,QSelect,QExpansionItem,QCheckbox,QInnerLoading,QSpinnerGears,QDialog,ClosePopup,Ripple} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QItemSection,QItemLabel,QChip,QAvatar,QBtn,QCardActions,QInput,QIcon,QSelect,QExpansionItem,QCheckbox,QInnerLoading,QSpinnerGears,QDialog}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup,Ripple}, component.options.directives || {})
